import styled from 'styled-components';

import { createGradientOrSolid } from 'utils';
import { Gradient } from 'utils/types';
import { breakpoints } from 'styles/breakpoints';
import { SubRollingOfferUiProps } from '../../../../shared/types';
import { motion } from 'framer-motion';
import { Box } from '@mui/material';

export interface StyledSubRollingOfferProps extends SubRollingOfferUiProps {
  clickable?: boolean;
}

interface SubOffersLayoutProps {
  direction?: string;
  justifyContent?: string;
}

interface SubRollingOfferPriceButtonProps {
  background?: Gradient;
  borderRadius?: string;
}

export const StyledSubRollingOfferPrice = styled.div<SubOffersLayoutProps>`
  display: flex;
  flex-direction: column;
  direction: ltr;
  justify-content: center;
  width: 100%;
  color: var(--button-text-color);
  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);

  .totalPrice {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
`;

export const StyledSubProductsContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 12px;
  gap: 2px;
  flex-direction: column;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: center;
`;

export const StyledSubRollingOfferPriceButton = styled.div<SubRollingOfferPriceButtonProps>`
  height: 30px;
  min-height: 30px;
  width: 100%;
  background: ${({ background }) =>
    background && createGradientOrSolid(background)};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 8px 8px;
  font-weight: 700;
  font-size: 14px;
  color: var(--button-text-color);
  position: relative;

  .white_stripe {
    position: absolute;
    top: 2px;
    height: 8px;
    width: 100%;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    );
  }

  .lockImage {
    position: absolute;
    left: 10px;
    transform-origin: center;
  }

  @media (max-width: 374px) {
    height: 30px;
  }
`;

export const StyledMainProduct = styled(motion.div)<{ title: string, color: string }>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 0;
  padding: 12px;
  box-sizing: border-box;

  .main-product-image {
    width: 64px;
    height: 64px;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .text {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center !important;
    position: relative;
    z-index: 1;

    .quantity {
      margin: 0;
      text-align: center;
      font-weight: 700;
      font-size: 14px;

      color: ${({ color }) => color};
      position: relative;
      direction: ltr;

      &:after {
        background: none;
        content: '${({ title }) => title}';
        left: 0;
        top: 0;
        z-index: -1;
        position: absolute;
        direction: ltr;
      }
    }
  }

  @media (max-width: ${breakpoints.mobileM}) {
    img {
      &.mainPic {
        width: 70px;
      }
    }

    .text {
      max-width: calc(100% - 75px);
    }
  }

  @media (max-width: ${breakpoints.mobileS}) {
    img.mainPic {
      width: 64px !important;
    }
  }
`;

export const StyledSubProduct = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  height: 28px;
  justify-content: start;

  .sub-product-image {
    width: 28px;
    height: 28px;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .text {
    max-width: calc(100% - 30px);
    padding: 0;

    p {
      font-size: 14px;
      font-weight: 600;
      color: ${(props: any) => props.color};
    }
  }
`;
